import { FormControl, RadioGroup, FormControlLabel, Radio, FormHelperText, Typography } from '@mui/material';
import React from 'react';
import { useFormState, useFormContext, useController } from 'react-hook-form';

const ControlledRadioButtonGroup = (props) => {
  const { setValue } = useFormContext();
  const { isDirty, errors } = useFormState();

  const { items, helperText, label, value, name, required, defaultValue, ...rest } = props;

  const { field } = useController({
    name,
  });

  let isError = false;
  let errorMessage = '';
  if (errors && Object.prototype.hasOwnProperty.call(errors, name)) {
    isError = true;
    errorMessage = errors[name]?.message?.toString() || '';
  }

  const [, setInternalValue] = React.useState(value || '');

  return (
    <FormControl component='fieldset' error={isError} required={required}>
      <Typography variant='caption' gutterBottom sx={{ lineHeight: 1, color: 'rgba(0, 0, 0, 0.6)' }}>
        {label} {required ? '*' : null}
      </Typography>
      <RadioGroup {...rest} {...field} row defaultValue={defaultValue}>
        {items.map((c) => (
          <FormControlLabel
            value={c.value}
            label={c.label}
            key={c.value}
            control={
              <Radio
                required={required}
                onChange={(e) => {
                  setInternalValue(e.target.value);
                  setValue(name, e.target.value);
                }}
              />
            }
          />
        ))}
      </RadioGroup>
      {isDirty && isError && (
        <FormHelperText>
          <span>{errorMessage}</span>
        </FormHelperText>
      )}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default ControlledRadioButtonGroup;
